// Human-readable labels/styles for a caller's Program-level authority
// tier — list_my_program_memberships()'s viewer_role ('owner'/'admin',
// 025). Program Owner and Program Admin are a completely separate
// concept from Season-Team-scoped roles (see utils/teamRoles.js) — never
// conflate the two.
export function programRoleLabel(viewerRole) {
  return viewerRole === 'owner' ? 'Program Owner' : 'Program Admin';
}

// Owner gets the same gold/amber tone already used for this app's other
// "elevated tier" indicator (the Nerds+ chip) — a deliberately different
// color from the existing green "Program Admin" chip, not a warning
// color reuse.
export function programRoleChipStyle(viewerRole) {
  return viewerRole === 'owner'
    ? { bgcolor: '#2a1a05', color: '#f5a623' }
    : { bgcolor: '#0a2a14', color: '#2ea84b' };
}
